/*
 * @Author: DQL
 * @Date: 2020-03-05 17:12:35
 * @LastEditors: DQL
 * @LastEditTime: 2022-11-07 16:31:16
 * @Description: file content
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

import { HMStoreService } from 'kestrel-core-ui';

import store from './store';
import config from './config';
// import { getSubject, systemPreloadInfo } from '@/features/feature.common.service.js';
import { systemPreloadInfo } from '@/features/feature.common.service.js';
// import menuTree from './menuTree';

import layout from '@/layout.vue';

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 消防系统管理
import systemManageRoutes from '@/features/systemManage/systemManage.routes.js';

// 系统管理
import systemRoutes from '@/features/system/system.routes.js';

// 工作流
// import workflowRoutes from '@/features/workflow/workflow.routes.js';

// 用户中心
// import userCenterRoutes from '@/features/userCenter/userCenter.routes.js';

// 示例
import examplesRoutes from '@/features/examples/examples.routes.js';

// 通用业务管理
import commonRoutes from '@/features/common/common.routes.js';

// 消防维保管理
import xfwbglRoutes from '@/features/xfwbgl/xfwbgl.routes.js';

// 消防检测管理
import xfjcglRoutes from '@/features/xfjcgl/xfjcgl.routes.js';
// 消防安全评估管理
import xfaqpgRoutes from '@/features/xfaqpg/xfaqpg.routes.js';

// 功能首页
import mainRoutes from '@/features/main/main.routes.js';

// 功能模块扩展（区域管理、设施类型管理、设备台账管理）
import gnmkRoutes from '@/features/gnmk/gnmk.routes.js';
import jxxfRoutes from '@/features/jxxf/jxxf.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/

const FEATURES_ROUTES = [systemManageRoutes, systemRoutes, examplesRoutes, xfwbglRoutes, xfjcglRoutes, xfaqpgRoutes, commonRoutes, mainRoutes, gnmkRoutes, jxxfRoutes];

/* 业务功能路由配置写入 End */

/* =============================================
   首页路由配置start
  *
  *
*/

const home = { template: '<div>home首页</div>' };
// 系统首页路由
const HOME_ROUTER_PATH = '/main';

/* 首页路由配置end */

Vue.use(VueRouter);

/* 重写VueRouter的push方法，解决由于版本问题出现的控制台错误输出
   [NavigationDuplicated {_name: "NavigationDuplicated", name: "NavigationDuplicated"}]
   Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理，因此就会报上述的错误。
*/
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error);
};

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/features/login.vue')
  },
  {
    path: '/bg/:xflx/:id',
    name: 'bgPreview',
    component: () => import(/* webpackChunkName: "bgPreview" */ '@/features/bg.vue')
  },
  {
    path: '/public/wbbg',
    name: 'publicWbbg',
    component: () => import(/* webpackChunkName: "publicWbbg" */ '@/features/xfwbgl/bggl/wbbgCommon.vue'),
    meta: {
      title: '消防维保信息查询',
      public: true // 标记为公开访问
    }
  },
  {
    path: '/',
    component: layout,
    redirect: HOME_ROUTER_PATH,
    beforeEnter: (to, from, next) => {
      // 进入根目录前检查是否登录
      const token = window.CookieUtil.get(config.localTokenName) || false;
      if (token) {
        systemPreloadInfo()
          .then(rsp => {
            /* 用户信息处理 Start */

            const userinfo = rsp[0].data;
            userinfo.roleTypeDm = (rsp[5].data && rsp[5].data.roleTypeDm) || '';
            HMStoreService.updateUserinfo(userinfo);

            /* 用户信息处理 End */

            /* 基础枚举 Start */
            const enums = rsp[1].data;
            HMStoreService.updateEnums(enums);

            /* 基础枚举 End */

            /* 页面元素 Start */

            const menuElement = rsp[2].data;
            HMStoreService.updateMenuElement(menuElement);

            /* 页面元素 End */

            /* 菜单 Start */

            const menuTree = rsp[3].data;
            HMStoreService.updateMenu(menuTree);

            /* 菜单 End */

            /* 业务枚举 Start 依据需要配置 */

            const apiEnums = [
              { name: 'iffApi', data: rsp[4].data }
            ];
            store.commit('UPDATE_ENUMS', apiEnums);

            /* 业务枚举 End */

            next();
          });
      } else {
        next('/login');
      }
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: home,
        meta: {
          navtabTitle: '首页',
          isCache: true,
          ignoreDiff: [],
          isIframe: false
        }
      },
      // iframe页面路由
      {
        path: 'iframePage',
        name: 'iframePage',
        component: { template: '<div></div>' },
        meta: {
          isCache: true,
          isIframe: true
        }
      },
      ...FEATURES_ROUTES
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
